import log from './util.log.js'
import cookies from './util.cookies.js'
import excel from './util.excel.js'

let util = {
  cookies,
  log,
  excel
}

/**
 * @param {Array} Tree
 */

util.traversalTree = function (list, callback, childrenKey = 'children') {
  if (!list && !Array.isArray(list)) {
    throw new Error('required an Array.')
  }
  // if(list.value == "commerce"){
  //   callback(list.children,list)
  // }
  for (const item of list) {
    const children = item.children
    if (children) {
      util.traversalTree(children, callback)
    } else {
      const isBreak = callback(item,list)
      if (isBreak) {
        break
      }
    }
  }
}

/**
 * @param {Array} Tree
 */

util.mapTree = function (list, callback) {
  for(let item of list){
    if(item.isEnd == "0"){
      // debugger
      // console.log(item.children)
    }else{
      const isJump = callback(item.children,list)
      if (isJump) {
        break
      }
    }
  }
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  const processTitle = window.vm.$i18n.t('index.title')
  window.document.title = `${processTitle}${titleText ? ` - ${titleText}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-menu-link')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-menu-link'))
}
/**
 * * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
util.isString = function (value) {
  return typeof value === 'string';
}

util.isNumber = function(value) {
  return typeof value === 'number';
}

/**
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
util.isUndefined =function(value) {
  return typeof value === 'undefined';
}

util.isEmpty = function (value) {
  return util.isUndefined(value) || value === '' || value === null || value !== value;
};
/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';
util.parse = function(numStr) {
  var exponent = 0,
    digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) { /* jshint noempty: false */ }

  if (i == (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return {
    d: digits,
    e: exponent,
    i: numberOfIntegerDigits
  };
}
/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
util.roundNumber=function(parsedNumber, fractionSize, minFrac, maxFrac) {
  var digits = parsedNumber.d;
  var fractionLen = digits.length - parsedNumber.i;

  // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
  fractionSize = (util.isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

  // The index of the digit to where rounding is to occur
  var roundAt = fractionSize + parsedNumber.i;
  var digit = digits[roundAt];

  if (roundAt > 0) {
    // Drop fractional digits beyond `roundAt`
    digits.splice(Math.max(parsedNumber.i, roundAt));

    // Set non-fractional digits beyond `roundAt` to 0
    for (var j = roundAt; j < digits.length; j++) {
      digits[j] = 0;
    }
  } else {
    // We rounded to zero so reset the parsedNumber
    fractionLen = Math.max(0, fractionLen);
    parsedNumber.i = 1;
    digits.length = Math.max(1, roundAt = fractionSize + 1);
    digits[0] = 0;
    for (var i = 1; i < roundAt; i++) digits[i] = 0;
  }

  if (digit >= 5) {
    if (roundAt - 1 < 0) {
      for (var k = 0; k > roundAt; k--) {
        digits.unshift(0);
        parsedNumber.i++;
      }
      digits.unshift(1);
      parsedNumber.i++;
    } else {
      digits[roundAt - 1]++;
    }
  }

  // Pad out with zeros to get the required fraction length
  for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


  // Do any carrying, e.g. a digit was rounded up to 10
  var carry = digits.reduceRight(function (carry, d, i, digits) {
    d = d + carry;
    digits[i] = d % 10;
    return Math.floor(d / 10);
  }, 0);
  if (carry) {
    digits.unshift(carry);
    parsedNumber.i++;
  }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
util.formatNumber=function(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(util.isString(number) || util.isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
    formattedText = '',
    parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = util.parse(numStr);

    util.roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function (isZero, d) {
      return isZero && !d;
    }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}
util.formats = {
  "CURRENCY_SYM": "$",
  "DECIMAL_SEP": ".",
  "GROUP_SEP": ",",
  "PATTERNS": [{
      "gSize": 3,
      "lgSize": 3,
      "maxFrac": 3,
      "minFrac": 0,
      "minInt": 1,
      "negPre": "-",
      "negSuf": "",
      "posPre": "",
      "posSuf": ""
    },
    {
      "gSize": 3,
      "lgSize": 3,
      "maxFrac": 2,
      "minFrac": 2,
      "minInt": 1,
      "negPre": "-\u00a4",
      "negSuf": "",
      "posPre": "\u00a4",
      "posSuf": ""
    }
  ]
}
util.demandState=function (data) {
  switch (data) {
    case '0':
      return '待提报'
    case '1':
      return '待受理'
    case '2':
      return '受理通过'
    case '3':
      return '已拒绝'
    case '4':
      return '已装车'
    case '5':
      return '已发车'
    case '6':
      return '已到达'
    case '7':
      return '已卸车'
    case '8':
      return '已交付'
    case '9':
      return '已作废'
    case '10':
      return '待受理'
    case '11':
      return '受理通过'
    case '12':
      return '已拒绝'

  }
}

util.phasedemandState=function (data) {
  switch (data) {
    case '0':
      return '待提报'
    case '1':
      return '待受理'
    case '2':
      return '受理通过'
    case '3':
      return '已拒绝'
  }
}
util.goodsNameFilter=function (data) {
  switch (data) {
    case '0':
      return '动力煤'
    case '1':
      return '炼焦煤'
    case '2':
      return '无烟煤'
    case '3':
      return '喷吹煤'
    case '4':
      return '块煤'
    case '5':
      return '兰炭'
    case '6':
      return '其他'
  }
}
util.goodsStateFilter=function (data) {
  switch (data) {
    case '0':
      return '正常'
    case '1':
      return '待审核'
    case '2':
      return '已拒绝'
    case '3':
      return '待发布'
    case '4':
      return '已发布'
    case '5':
      return '待确认'
    case '6':
      return '已确认'
    case '7':
      return '对方拒绝'
  }
}


export default util
